export { YotpoReferrals } from '@/components/common/YotpoReferrals/YotpoReferrals';
